<div class="max-w-[460px]">
  <main class="auth__panel">
    <div class="auth-panel shadow-md">
      <p
        [class.text-brand-600]="isWealthOnline"
        [class.text-gray-400]="isOtto1890"
        class="text-lg font-heavy leading-md">
        404 Error
      </p>
      <h1
        [class.font-heavy]="isWealthOnline"
        [class.text-gray-900]="isWealthOnline"
        [class.text-white]="isOtto1890"
        class="my-[12px] text-5xl leading-5xl">
        Page Not Found
      </h1>
      <p
        [class.text-gray-600]="isWealthOnline"
        [class.text-white]="isOtto1890"
        class="text-xl font-book leading-xl">
        Sorry, the page you are looking for doesn't exist or has been moved. Here are some helpful
        links:
      </p>

      <div class="mt-[32px] flex w-full gap-4">
        <ui-button
          (click)="back()"
          appearance="stroked"
          color="secondary"
          label="Go Back">
        </ui-button>
        <ui-button
          [routerLink]="['/private/landing']"
          color="secondary"
          label="Take Me Home">
        </ui-button>
      </div>
    </div>
  </main>
</div>
